/**
 * Header Module
 */

export default function initHeader() {
  const header = document.querySelector('.header');
  if (!header) return;

  // Sticky header on scroll
  let lastScroll = 0;
  
  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    
    if (currentScroll > 100) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
    
    // Hide header on scroll down, show on scroll up
    if (currentScroll > lastScroll && currentScroll > 200) {
      header.classList.add('hidden');
    } else {
      header.classList.remove('hidden');
    }
    
    lastScroll = currentScroll;
  });

  // Keep --header-height CSS variable in sync with actual header height
  function updateHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  updateHeaderHeight();
  new ResizeObserver(updateHeaderHeight).observe(header);

  // Mobile menu toggle
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('active');
      menuToggle.classList.toggle('active');
      document.body.classList.toggle('menu-open');
    });
  }
}

function equaliseMegaMenuLinks() {
  document.querySelectorAll('.mega-menu-column > .mega-sub-menu').forEach(function(subMenu) {
    var links = subMenu.querySelectorAll(':scope > .mega-menu-item > .mega-menu-link');
    if (links.length < 2) return;

    links.forEach(function(link) { link.style.height = ''; });

    var max = 0;
    links.forEach(function(link) {
      var h = link.offsetHeight;
      if (h > max) max = h;
    });

    links.forEach(function(link) { link.style.height = max + 'px'; });
  });
}

// Auto-initialize
document.addEventListener('DOMContentLoaded', function() {
  initHeader();
  equaliseMegaMenuLinks();

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equaliseMegaMenuLinks, 150);
  });
});
